import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

// Pages
import HomePage from "@/pages/HomePage";
import BrandifyAbout from "@/pages/brandify/About";
import BrandifyServices from "@/pages/brandify/Services";
import BrandifyCaseStudies from "@/pages/brandify/CaseStudies";
import BrandifyProcess from "@/pages/brandify/Process";
import BrandifyContact from "@/pages/brandify/Contact";
import StudioAbout from "@/pages/studio/About";
import StudioServices from "@/pages/studio/Services";
import StudioPortfolio from "@/pages/studio/Portfolio";
import StudioContact from "@/pages/studio/Contact";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminLogin from "@/pages/admin/Login";

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          
          {/* Brandify Routes */}
          <Route path="/brandify/about" element={<BrandifyAbout />} />
          <Route path="/brandify/services" element={<BrandifyServices />} />
          <Route path="/brandify/case-studies" element={<BrandifyCaseStudies />} />
          <Route path="/brandify/process" element={<BrandifyProcess />} />
          <Route path="/brandify/contact" element={<BrandifyContact />} />
          
          {/* Studio Routes */}
          <Route path="/studio/about" element={<StudioAbout />} />
          <Route path="/studio/services" element={<StudioServices />} />
          <Route path="/studio/portfolio" element={<StudioPortfolio />} />
          <Route path="/studio/contact" element={<StudioContact />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
    </HelmetProvider>
  );
}

export default App;